document.addEventListener('DOMContentLoaded', function () {
  var _srLoaded = false;

  function initScrollReveal() {
    if (_srLoaded) return;
    _srLoaded = true;

    if (typeof window.ScrollReveal === 'function') {
      setupScrollReveal();
      return;
    }

    if (document.querySelector('script[data-cdl-scroll-reveal]')) return;

    var s = document.createElement('script');
    s.dataset.cdlScrollReveal = 'true';
    s.src = 'https://unpkg.com/scrollreveal@4.0.0/dist/scrollreveal.min.js';
    s.onload = setupScrollReveal;
    document.head.appendChild(s);
  }

  function setupScrollReveal() {
      if (typeof window.ScrollReveal !== 'function') return;
      window.sr = ScrollReveal({
        duration: 800,
        origin: 'bottom',
        distance: '25px',
        scale: 0.85,
      });
      sr.reveal('.product-card-wrapper', { interval: 100 });
      sr.reveal('.collection-card', { interval: 100 });
      sr.reveal('.article-card-wrapper', { interval: 100 });
      sr.reveal('.sr-animate--no-interval');
  }

  window.addEventListener('scroll', initScrollReveal, { once: true, passive: true });
  setTimeout(initScrollReveal, 500);
});
